import type { TaskPermission, WorkflowTasksPermissionsResponse } from 'garaje/types/workflow-approvals';

/**
 * Derives whether the current user can approve a workflow by inspecting the
 * tasks/permissions response. Keeps only the latest run per nodeInstanceId
 * (highest runNumber), then checks if the task is an approval node, is pending,
 * and requestUserId matches a participant with roleType 'APPROVER'.
 */
export function deriveCanApproveWorkflow(response: WorkflowTasksPermissionsResponse): boolean {
  const { requestUserId, tasks } = response;
  if (!tasks?.length) return false;

  // Keep only the task with the highest runNumber per nodeInstanceId.
  // Using a plain object instead of Map to avoid ember/use-ember-get-and-set lint false positives.
  const latestByNode: Record<string, TaskPermission> = {};
  for (const task of tasks) {
    const existing = latestByNode[task.nodeInstanceId];
    if (!existing || task.runNumber > existing.runNumber) {
      latestByNode[task.nodeInstanceId] = task;
    }
  }

  return Object.values(latestByNode).some(
    (task) =>
      task.nodeType === 'approval' &&
      task.statusId === 'pending' &&
      task.participants.some((p) => p.roleType === 'APPROVER' && p.participantId === requestUserId),
  );
}
